import React from 'react';
import ReactDOM from 'react-dom/client';
// AdminGate.tsx
import { Auth0Provider, useAuth0 } from '@auth0/auth0-react';
import './index.css';
import { Provider } from 'react-redux';
import { BrowserRouter, useNavigate } from 'react-router-dom';
import { AdminWrapper } from './App';
import { store } from './store/store';
import { setDispatch } from './store/dispatchAccessor';

setDispatch(store.dispatch);

const domain = process.env.REACT_APP_AUTH0_DOMAIN!;
const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID!;
const audience = process.env.REACT_APP_AUTH0_AUDIENCE!;

// Small helper to wire navigation after login redirect:
const Auth0ProviderWithNavigate = ({ children }: { children: React.ReactNode }): JSX.Element => {
	const navigate = useNavigate();
	const onRedirectCallback = (appState?: { returnTo?: string }): void => {
		navigate(appState?.returnTo || window.location.pathname, { replace: true });
	};

	return (
		<Auth0Provider
			domain={domain}
			clientId={clientId}
			redirectUri={window.location.origin}
			audience={audience}
			useRefreshTokens
			onRedirectCallback={onRedirectCallback}
		>
			{children}
		</Auth0Provider>
	);
};

const AdminGate = ({ children }: { children: React.ReactNode }): JSX.Element => {
	const { isLoading, isAuthenticated, loginWithRedirect, error } = useAuth0();

	if (isLoading) {
		return <div>Loading…</div>;
	}

	if (error) {
		return <div>Auth error: {String(error.message || error)}</div>;
	}

	if (!isAuthenticated) {
		// Kick off login; return null to avoid rendering anything that would request a token
		loginWithRedirect({
			appState: { returnTo: window.location.pathname + window.location.search },
			authorizationParams: {
				prompt: 'select_account', // optional: forces account chooser
			},
		});

		return null;
	}

	return <>{children}</>;
};

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
	<Provider store={store}>
		<BrowserRouter>
			<Auth0ProviderWithNavigate>
				<AdminGate>
					<AdminWrapper />
				</AdminGate>
			</Auth0ProviderWithNavigate>
		</BrowserRouter>
	</Provider>
);
